import { AppBar, Container, Toolbar, useTheme } from '@mui/material';
import { t } from 'i18next';
import React, { FC, PropsWithChildren } from 'react';

interface NavbarProps {
  fullWidth?: boolean;
}

type MaterialMaxWidthType = 'xs' | 'sm' | 'md' | 'lg' | 'xl' | false;

const Navbar: FC<PropsWithChildren<NavbarProps>> = ({ children, fullWidth }) => {
  const theme = useTheme();
  const ToolbarWrapper = fullWidth ? React.Fragment : Container;
  const toolbarWrapperProps = fullWidth
    ? {}
    : ({ maxWidth: theme.appBar.maxWidth } as { maxWidth: MaterialMaxWidthType });

  return (
    <>
      <AppBar
        color={theme.appBar.background as any}
        elevation={0}
        position={theme.appBar.position as any}
        sx={{
          color: theme.appBar.resolveColor(),
          zIndex: theme.zIndex.appBar + 1,
        }}
      >
        <nav aria-label={t('navbar.landmark')} role="navigation">
          <ToolbarWrapper {...toolbarWrapperProps}>
            <Toolbar disableGutters variant="dense">
              {children}
            </Toolbar>
          </ToolbarWrapper>
        </nav>
      </AppBar>
      {theme.appBar.position === 'fixed' && <div style={{ height: theme.appBar.height }} />}
    </>
  );
};

export default Navbar;
